export default __webpack_public_path__ + "static/media/mdsz.290ef50a.png";